// ================================================================
// EXPORTS.JS - Sistema de Exportação PDF/Excel
// ================================================================

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Pages = window.FazendaRP.Pages || {};
window.FazendaRP.Pages.operacional = window.FazendaRP.Pages.operacional || {};

window.FazendaRP.Pages.operacional.exports = {

    /**
     * Exportar Prescrições para Excel
     */
    async exportPrescricoesExcel() {
        try {
            const { data: prescricoes } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .order('data_inicio', { ascending: false });

            if (!prescricoes || prescricoes.length === 0) {
                alert('Nenhuma prescrição para exportar');
                return;
            }

            // Criar CSV
            const headers = ['Data', 'Nome', 'Status', 'Tipo', 'Custo Estimado (R$)', 'Observações'];
            const rows = prescricoes.map(p => [
                new Date(p.data_inicio).toLocaleDateString('pt-BR'),
                p.nome,
                p.status,
                p.tipo_operacao,
                (p.custo_estimado || 0).toFixed(2),
                p.observacoes || ''
            ]);

            const csvContent = [
                headers.join(','),
                ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
            ].join('\n');

            // Download
            this.downloadFile(csvContent, 'prescricoes.csv', 'text/csv;charset=utf-8;');

            window.FazendaRP.Toast?.show('success', 'Exportado', 'Prescrições exportadas com sucesso!');

        } catch (err) {
            console.error('Erro ao exportar:', err);
            alert('Erro ao exportar prescrições');
        }
    },

    /**
     * Exportar Atividades para Excel
     */
    async exportAtividadesExcel(filtros = {}) {
        try {
            let query = window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .order('data_atividade', { ascending: false });

            // Aplicar filtros se necessário
            if (filtros.tipo) query = query.eq('tipo_operacao', filtros.tipo);
            if (filtros.dataInicio) query = query.gte('data_atividade', filtros.dataInicio);
            if (filtros.dataFim) query = query.lte('data_atividade', filtros.dataFim);

            const { data: atividades } = await query;

            if (!atividades || atividades.length === 0) {
                alert('Nenhuma atividade para exportar');
                return;
            }

            // Criar CSV
            const headers = ['Data Início', 'Data Fim', 'Tipo', 'Área (ha)', 'Custo (R$)', 'Operador', 'Observações'];
            const rows = atividades.map(a => [
                new Date(a.data_atividade).toLocaleDateString('pt-BR'),
                a.data_fim ? new Date(a.data_fim).toLocaleDateString('pt-BR') : '',
                a.tipo_operacao,
                (a.area_aplicada || 0).toFixed(2),
                (a.custo_total || 0).toFixed(2),
                a.operador || '',
                a.observacoes || ''
            ]);

            const csvContent = [
                headers.join(','),
                ...rows.map(row => row.map(cell => `"${cell}"`).join(','))
            ].join('\n');

            this.downloadFile(csvContent, 'atividades.csv', 'text/csv;charset=utf-8;');

            window.FazendaRP.Toast?.show('success', 'Exportado', 'Atividades exportadas com sucesso!');

        } catch (err) {
            console.error('Erro ao exportar:', err);
            alert('Erro ao exportar atividades');
        }
    },

    /**
     * Exportar Dashboard para PDF (Simples - apenas dados)
     */
    async exportDashboardPDF() {
        try {
            const shared = window.FazendaRP.Pages.operacional.shared;

            // Coletar dados
            const areaTotal = shared.variedadesCache.reduce((sum, v) => sum + parseFloat(v.area_hectares || 0), 0);

            const { data: prescricoes } = await window.FazendaRP.supabase
                .from('operacional_prescricoes')
                .select('*')
                .in('status', ['Pendente', 'Aprovada']);

            const dataLimite = new Date();
            dataLimite.setDate(dataLimite.getDate() - 30);

            const { data: atividades } = await window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .gte('data_atividade', dataLimite.toISOString().split('T')[0]);

            const custoTotal = (atividades || []).reduce((sum, a) => sum + (parseFloat(a.custo_total) || 0), 0);

            // Criar HTML para impressão
            const printWindow = window.open('', '', 'width=800,height=600');
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Relatório Operacional - Dashboard</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        h1 { color: #059669; border-bottom: 3px solid #059669; padding-bottom: 10px; }
                        .metric { background: #f9fafb; padding: 15px; margin: 10px 0; border-left: 4px solid #059669; }
                        .metric-title { font-weight: bold; color: #6b7280; font-size: 0.9rem; }
                        .metric-value { font-size: 2rem; font-weight: bold; color: #1f2937; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                        th, td { border: 1px solid #d1d5db; padding: 8px; text-align: left; }
                        th { background: #f3f4f6; font-weight: bold; }
                        .footer { margin-top: 30px; text-align: center; color: #9ca3af; font-size: 0.8rem; }
                    </style>
                </head>
                <body>
                    <h1>📊 Relatório Operacional - Dashboard</h1>
                    <p><strong>Gerado em:</strong> ${new Date().toLocaleString('pt-BR')}</p>
                    
                    <h2>Métricas Gerais</h2>
                    <div class="metric">
                        <div class="metric-title">Área Total</div>
                        <div class="metric-value">${areaTotal.toFixed(1)} ha</div>
                    </div>
                    
                    <div class="metric">
                        <div class="metric-title">Prescrições Ativas</div>
                        <div class="metric-value">${prescricoes?.length || 0}</div>
                    </div>
                    
                    <div class="metric">
                        <div class="metric-title">Atividades (30 dias)</div>
                        <div class="metric-value">${atividades?.length || 0}</div>
                    </div>
                    
                    <div class="metric">
                        <div class="metric-title">Custo Total (30 dias)</div>
                        <div class="metric-value">R$ ${custoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                    </div>
                    
                    <h2>Variedades Cadastradas</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Área (ha)</th>
                                <th>Cultura</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${shared.variedadesCache.map(v => `
                                <tr>
                                    <td>${v.nome}</td>
                                    <td>${v.area_hectares}</td>
                                    <td>${v.cultura_atual}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    
                    <div class="footer">
                        <p>Fazenda Rio do Peixe e Fartura - Sistema de Gestão Operacional</p>
                    </div>
                    
                    <script>
                        window.onload = () => {
                            window.print();
                            setTimeout(() => window.close(), 500);
                        };
                    </script>
                </body>
                </html>
            `);
            printWindow.document.close();

        } catch (err) {
            console.error('Erro ao exportar PDF:', err);
            alert('Erro ao gerar PDF');
        }
    },

    /**
     * Exportar Relatório Completo de Atividades (PDF com formatação)
     */
    async exportRelatorioAtividadesPDF(filtros = {}) {
        try {
            let query = window.FazendaRP.supabase
                .from('operacional_atividades')
                .select('*')
                .order('data_atividade', { ascending: false })
                .limit(100);

            if (filtros.tipo) query = query.eq('tipo_operacao', filtros.tipo);
            if (filtros.dataInicio) query = query.gte('data_atividade', filtros.dataInicio);
            if (filtros.dataFim) query = query.lte('data_atividade', filtros.dataFim);

            const { data: atividades } = await query;

            if (!atividades || atividades.length === 0) {
                alert('Nenhuma atividade para exportar');
                return;
            }

            const custoTotal = atividades.reduce((sum, a) => sum + (parseFloat(a.custo_total) || 0), 0);
            const areaTotal = atividades.reduce((sum, a) => sum + (parseFloat(a.area_aplicada) || 0), 0);

            const printWindow = window.open('', '', 'width=900,height=700');
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Relatório de Atividades</title>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; }
                        h1 { color: #059669; border-bottom: 3px solid #059669; padding-bottom: 10px; }
                        .summary { background: #f0fdf4; padding: 15px; margin: 20px 0; border-radius: 8px; }
                        .summary-item { display: inline-block; margin-right: 30px; }
                        .summary-label { color: #6b7280; font-size: 0.85rem; }
                        .summary-value { font-size: 1.5rem; font-weight: bold; color: #059669; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 0.9rem; }
                        th, td { border: 1px solid #d1d5db; padding: 10px; text-align: left; }
                        th { background: #f3f4f6; font-weight: bold; }
                        tr:nth-child(even) { background: #f9fafb; }
                        .footer { margin-top: 30px; text-align: center; color: #9ca3af; font-size: 0.8rem; }
                        @media print {
                            @page { margin: 1cm; }
                        }
                    </style>
                </head>
                <body>
                    <h1>📝 Relatório de Atividades Operacionais</h1>
                    <p><strong>Período:</strong> ${filtros.dataInicio || 'Todos'} até ${filtros.dataFim || 'Hoje'}</p>
                    <p><strong>Gerado em:</strong> ${new Date().toLocaleString('pt-BR')}</p>
                    
                    <div class="summary">
                        <div class="summary-item">
                            <div class="summary-label">Total de Atividades</div>
                            <div class="summary-value">${atividades.length}</div>
                        </div>
                        <div class="summary-item">
                            <div class="summary-label">Área Total (ha)</div>
                            <div class="summary-value">${areaTotal.toFixed(1)}</div>
                        </div>
                        <div class="summary-item">
                            <div class="summary-label">Custo Total (R$)</div>
                            <div class="summary-value">${custoTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</div>
                        </div>
                    </div>
                    
                    <table>
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Tipo</th>
                                <th>Área (ha)</th>
                                <th>Custo (R$)</th>
                                <th>Operador</th>
                                <th>Observações</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${atividades.map(a => `
                                <tr>
                                    <td>${new Date(a.data_atividade).toLocaleDateString('pt-BR')}</td>
                                    <td>${a.tipo_operacao}</td>
                                    <td>${(a.area_aplicada || 0).toFixed(2)}</td>
                                    <td>${(a.custo_total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                                    <td>${a.operador || '-'}</td>
                                    <td>${(a.observacoes || '').substring(0, 50)}${(a.observacoes || '').length > 50 ? '...' : ''}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    
                    <div class="footer">
                        <p>Fazenda Rio do Peixe e Fartura - Sistema de Gestão Operacional</p>
                        <p>Este relatório contém ${atividades.length} atividade(s)</p>
                    </div>
                    
                    <script>
                        window.onload = () => {
                            window.print();
                            setTimeout(() => window.close(), 500);
                        };
                    </script>
                </body>
                </html>
            `);
            printWindow.document.close();

        } catch (err) {
            console.error('Erro ao exportar PDF:', err);
            alert('Erro ao gerar PDF de atividades');
        }
    },

    /**
     * Helper para download de arquivos
     */
    downloadFile(content, filename, mimeType) {
        const blob = new Blob([content], { type: mimeType });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
};
